import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

function Main() {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-yellow-400 to-orange-500 text-white">
      <Navbar />

      {/* Main content area */}
      <main className="pt-24 px-4 flex-grow">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}

export default Main;
